
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 41 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M25.731 10H15.386a4.828 4.828 0 00-4.827 4.828v10.345A4.829 4.829 0 0015.386 30h10.345a4.829 4.829 0 004.828-4.828V14.827A4.829 4.829 0 0025.73 10zm3.104 14.828a3.45 3.45 0 01-3.449 3.449h-9.655a3.45 3.45 0 01-3.449-3.449v-9.655a3.45 3.45 0 013.449-3.449h9.655a3.45 3.45 0 013.449 3.449v9.655zm-8.28-10A5.175 5.175 0 0015.384 20a5.175 5.175 0 005.173 5.172 5.175 5.175 0 005.173-5.172 5.175 5.175 0 00-5.173-5.173zm0 8.62A3.454 3.454 0 0117.108 20c0-1.9 1.549-3.449 3.449-3.449S24.004 18.1 24.004 20s-1.548 3.448-3.448 3.448zm4.483-8.963a1.036 1.036 0 101.035-1.035c-.57 0-1.035.464-1.035 1.035z","fill":"#fff"}}),_c('path',{attrs:{"d":"M31.939 40H9.06C4.341 40 .5 36.159.5 31.439V8.56C.5 3.841 4.341 0 9.061 0H31.94c4.72 0 8.561 3.841 8.561 8.561V31.44c0 4.72-3.841 8.561-8.561 8.561zM9.06 1.557A7.012 7.012 0 002.057 8.56V31.44a7.012 7.012 0 007.004 7.004H31.94a7.012 7.012 0 007.004-7.004V8.56a7.012 7.012 0 00-7.004-7.004H9.06z","fill":"#fff"}})])
          )
        }
      }
    